import { Component, OnInit, ViewChild } from '@angular/core';
import { MemberofficeService } from '@app/services/memberoffices/memberoffice.service';
import { ClaimsService } from '@app/services/claims/claims.service';
import { MemberService } from '@app/services/member.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PdfService } from '@app/services/pdf/pdf.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { DatePipe } from '@angular/common';

interface MeetingSums {
  ordinariesum: number;
  sommarsum: number;
  ovrigtsum: number;
}

@Component({
  selector: 'app-matrix',
  templateUrl: './matrix.component.html',
  styleUrls: ['./matrix.component.css']
})
export class MatrixComponent implements OnInit {
  @ViewChild('contentToConvert', { static: true }) content;
  matrixdata;
  memberid: number;
  emptyarr = [];
  imageToShow: any;
  imagewidth;
  imageheight;
  ordinariesum = 0;
  sommarsum = 0;
  ovrigtsum = 0;
  id;
  summor: MeetingSums[] = [];
  timestamp;
  can_view_memfee = false;
  // tslint:disable-next-line:max-line-length
  constructor(private memberOfficeService: MemberofficeService, private datePipe: DatePipe, private permissionService: PermissionsService, private route: ActivatedRoute, private pdfService: PdfService, private router: Router, private claimService: ClaimsService, private memberService: MemberService) { }

  ngOnInit() {

    this.memberid = this.claimService.getActualMemberId();

    this.route.params.subscribe(params => {
      if (params) {
        this.matrixdata = [];
        this.id = params['id'];

        this.imageToShow = null;
        // Hämta bild på medlemmen
        this.getImageFromService();

        const list: number[] = [];
        list.push(params['id']);
        this.createMatrix(list);
      }
    });

    this.permissionService.selectedrole.subscribe(r => {
      if (r) {
        this.setPermissions();
      }
    });
  }

  setPermissions() {{}
   /* if (this.id) {
      this.permissionService.hasPermissionForMember('VIEW_MEMFEE', this.id).subscribe(p => {
        if (p) {
          this.can_view_memfee = p;
        }
      });
    }*/
    const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole')).permissions;
    this.can_view_memfee = user_permissions.indexOf('VIEW_MEMFEE') !== -1;
  }

  createMatrix(list: number[]) {
     const selectedroleid = +JSON.parse(sessionStorage.getItem('selectedrole')).roleId;
    this.timestamp = new Date();
    this.memberOfficeService.GetMemberMainListing(selectedroleid, list).subscribe(response => {
      if (response) {

        this.matrixdata.push(response[0]);

        if (response[0].fees?.length > 0) {
          this.matrixdata[0].fees.forEach(f => {
            f.totalAmountToPay = Math.round(f.totalAmountToPay);
            f.totalPaidAmount = Math.round(f.totalPaidAmount);
            f.balance = Math.round(f.balance);
          });
        }
      }
    });

  }
  getSum(list, column): number {
    let sum = 0;
    for (let i = 0; i < list.length; i++) {
      sum += list[i][column];
    }
    return sum;
  }

  getImageFromService() {
    this.memberService.GetMemberImageThumbnail(this.id).subscribe(data => {
      this.createImageFromBlob(data);
    }, error => {
      this.imageToShow = null;
    });
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;
      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);

    if (image) {
      reader.readAsDataURL(image);
    }
  }

  getSize(imgdata) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width;
      self.imageheight = image.height;

    });
    image.src = imgdata;
  }

  captureScreen() {
    const filename = 'Matrikelkort_' + this.matrixdata[0].familyName + '_' + this.matrixdata[0].givenName + '_' + this.matrixdata[0].id + '_' + this.datePipe.transform(new Date(), 'yyMMdd') + '.pdf';
    this.pdfService.captureScreen(this.content, 'p', filename);
    this.router.navigate(['/memberform/id/', this.id]);
   }

}
